import axios from 'axios'
import { EVENT_PLACE_LOCATION, USER_TOKEN } from "./CONSTANTS";

export const getEventPlaceLocations = () => {
  console.info("EventPlaceServices > getEventPlaces...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT_PLACE_LOCATION(),{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addEventPlaceLocation = (model) => {
  console.info("EventPlaceServices > addEventPlace...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT_PLACE_LOCATION(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const updateEventPlaceLocation = (model) => {
  console.info("updateSupplierServices > updateEventPlace...");
  return new Promise((resolve, reject) => {
      axios
      .put(EVENT_PLACE_LOCATION(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const deleteEventPlaceLocation = (uniqueKey) => {
  console.info("EventPlaceServices > deleteEventPlace...");
  return new Promise((resolve, reject) => {
      axios
      .delete(EVENT_PLACE_LOCATION()+'/'+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};